import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';

import { SeeItems } from './see-items.action';

export function seeItemsReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__SEE_ITEMS, SeeItems>,
): EventCentreDialogState {
    try {
        return {
            ...state,
            seenItems: state.items?.map((e) => e.eventCentreItemId),
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
